import { GLOBAL_PLACEMENT_MIDDLEWARE_CACHE_CONTROL } from '@post-office/message-maker-node/placements/custom-headers';
import {
	type createDefaultPlacementMiddleware,
	flattenMessagesForFrontend,
	heuristicForPostOfficeFailure,
} from '@post-office/message-maker-node/placements/middleware';
import { SortingMethod } from '@post-office/shared-contracts/shared-request-middleware-context/context';

// https://switcheroo.atlassian.com/ui/gates/5cf8ee8e-c3d9-4c77-b8ae-5b640ecd1b9a/key/post-office_enable_reranking-confluence-side-nav
export const ENABLE_RERANKING_CONFLUENCE_SIDE_NAV =
	'post-office_enable_reranking-confluence-side-nav';

export const runConfluenceSideNavPlacement: Parameters<
	typeof createDefaultPlacementMiddleware
>[0] = async ({ postOffice, request, koa }) => {
	const atlassianAccountId = request.orchestrationContext.recipient?.userId;

	// Same cache-control behaviour as placementMiddlewareWithCacheControlNav
	const isPostOfficeSynthetic =
		atlassianAccountId &&
		request.statsig.checkGate(
			{ identifiers: { atlassianAccountId } },
			'post-office-is-post-office-synthetic',
		);
	if (!isPostOfficeSynthetic) {
		koa.ctx.set({ ['cache-control']: GLOBAL_PLACEMENT_MIDDLEWARE_CACHE_CONTROL });
	}

	const enableReranking =
		!!atlassianAccountId &&
		request.statsig.checkGate(
			{ identifiers: { atlassianAccountId } },
			ENABLE_RERANKING_CONFLUENCE_SIDE_NAV,
		);

	const result = await postOffice.messagesRuntime({
		params: enableReranking
			? { sortingMethod: SortingMethod.DEFAULT_ML_RECOMMENDATIONS }
			: undefined,
	});

	heuristicForPostOfficeFailure(result);

	return {
		...result.data,
		messages: flattenMessagesForFrontend(result.data.messages),
	};
};
